import { useEffect } from "react"

import LocomotiveScroll from "locomotive-scroll"

import { scroll } from "../theme"

var current = 0;

function scrollingFunction(scroll) {
    var speed = scroll.speed;
    var rotation = scroll.scroll.y*.15;
    var current = (scroll.scroll.y).toFixed(0);
    var max = scroll.limit.y - 32;  
    var maxF = scroll.limit.y - window.innerHeight*2;
    var intensity = 950;    
    var veloicty = (speed/intensity).toFixed(4); 
    veloicty = 1 + Math.abs(veloicty);  

    
    var images = document.querySelectorAll('.image-will--scale'); 
    for (var i = 0; i < images.length; i++) {
      images[i].style.transform = 'scale('+veloicty+')'; 
    } 

    var icon = document.querySelector('.icon-will--rotate');
    icon.style.transform = 'rotate('+rotation+'deg)';  

    var bottomMenu = document.querySelector('.bottom-menu--fixed');

    if(current > 100 ) { 
      bottomMenu.classList.add('is-active');
    } else {
      bottomMenu.classList.remove('is-active'); 
    }

    if (current > maxF) {
      document.querySelector('.page--navigation').classList.remove('is-showing');
    } else {
      document.querySelector('.page--navigation').classList.add('is-showing'); 
    }

    if(window.innerWidth > 768) {
      if(current > max ) {  
        var bottom = Math.abs(max-current).toFixed(0);  
        bottomMenu.style.bottom = bottom+'px';  
      } else {
        bottomMenu.style.bottom = '0px';  
      }
    }
} 
 
const Scroll = callbacks => {
  useEffect(() => {
  	if (typeof window === 'undefined' || !window.document) {
      return;
    }
    let locomotiveScroll
    locomotiveScroll = new LocomotiveScroll({
      el: document.querySelector(scroll.container),
      ...scroll.options,
    })
    locomotiveScroll.update()

    window.scroll = locomotiveScroll

    locomotiveScroll.on('call', (value, way, obj) => {
      var target = obj.target;
      if(!target) {
        target = obj.targetEl;
      }  

      if (value === 'change-slide') {
        changeSlide(target, obj);
      } 

      if (value === 'change-color') {
        changeColor(target, obj);
      } 

      if (value === 'fade-image') {
        fadeImage();
      } 
    });

    function fadeImage() {
      var direction = document.documentElement.getAttribute('data-direction'); 
      var scale = document.querySelector('.image--scaled');
      var fades = document.querySelector('.image--fades');
      if(direction==='up') {
        scale.classList.remove('is-scaled');
        fades.classList.remove('is-faded');
      } else {
        scale.classList.add('is-scaled');
        fades.classList.add('is-faded');  
      }
    }

    function changeColor(target, obj) {
      var direction = document.documentElement.getAttribute('data-direction'); 
      var up = target.getAttribute('data-color-up');
      var down = target.getAttribute('data-color-down');
      if(direction==='up') {
        document.querySelector('main').style.background=up;
      } else {
        document.querySelector('main').style.background=down;
      }
    }

    function updateLocomotive() {
      locomotiveScroll.update()
    }

    function changeSlide(target, obj) { 
      var direction = document.documentElement.getAttribute('data-direction'); 
      var slide = target.getAttribute('data-slide');
      var max = document.querySelector('.page--navigation').getAttribute('data-max');

      if((direction==='down' && obj.inView) || (direction==='up' && !obj.inView)) {  
        document.querySelector('.page--navigation').setAttribute('data-slide', slide)
        var percent = slide/max - 1/max; 
        if(direction==='up') {
          percent = percent - 1/max;
        }
        percent = percent*100;  
        if(percent < 0) {
          percent=0;
        }
        if(percent > 100) {
          percent=100;
        } 
        document.querySelector('.page--navigation .slide .inner').style.transform = "translateY(-"+percent+"%)"; 
      }
    }

    if(document.querySelector('.sections-with--navigation')) {
      document.querySelector('.page--navigation').classList.add('is-active');
      var inner = document.querySelector('.page--navigation .slide .inner');
      var slides = document.querySelectorAll('.slide--marker');
      var count = document.querySelector('.page--navigation .total .count');
      count.innerHTML= slides.length;
      document.querySelector('.page--navigation').setAttribute('data-max', slides.length); 
      for (var i = 0; i < slides.length; i++) { 
        var num = i+1;
        var text = document.querySelectorAll('.image-with--caption')[i].getAttribute('data-title');
        if(text===null) { text='' }
        inner.innerHTML=inner.innerHTML+'<span class="count">0'+num+' '+text+'</span>';
      }
    }  

    if(document.querySelector('.slide-marker--color ')) {
      document.querySelector('main').setAttribute('data-bg-transition',true);
    }

    document.querySelector('.up--arrow').addEventListener("click", function(e) {
      locomotiveScroll.scrollTo('top')
    });

    window.addEventListener('load', (event) => {
      updateLocomotive();
    });

    locomotiveScroll.on("scroll", func => {
      var scroll = func.scroll.y.toFixed(0); 
      if(scroll !== current) {
        current = scroll;
        scrollingFunction(func); 
        document.documentElement.setAttribute("data-direction", func.direction)
      }
    })

    return () => {
      if (locomotiveScroll) locomotiveScroll.destroy()
    }
  }, [callbacks])



  return null
}

export default Scroll